import React, { useState, useEffect } from "react";
import { TextField, MenuItem, Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  GetAllAdminDetails,
  getavaliableTarget,
  postTargetapi,
} from "../../../../apiServices";
import { MyModal } from "../../../../utility";
import ModalContainer from "../../../../components/modal_popup";
import SuccessTick from "../../../../components/success_tick";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const TargetPostForm = ({ onclose }) => {
  const [formData, setFormData] = useState({
    month: "",
    admins: [],
    targetAmount: "",
  });

  const [errors, setErrors] = useState({
    month: false,
    admins: false,
    targetAmount: false,
  });
  const [admins, setAdmins] = useState();
  const [adminOptions, setAdminOptions] = useState([]);
  const [targetopen, setTargetOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [enableSubmit, setenableSubmit] = useState(false);

  // useEffect(() => {
  //   const now = new Date();
  //   const currentMonthYear = `${months[now.getMonth()]} ${now.getFullYear()}`;
  //   setFormData((prev) => ({ ...prev, month: currentMonthYear }));

  //   const fetchAdminsAndTargets = async () => {
  //     try {
  //       const adminData = await GetAllAdminDetails();
  //       const activeAdmins = adminData.filter(
  //         (item) => !item.Deactived && item.module !== "Developer"
  //       );
  //       const formattedAdmins = activeAdmins.map((item) => ({
  //         id: item.id,
  //         name: item.userName,
  //       }));
  //       setAdmins(formattedAdmins);
  //       console.log(formattedAdmins, "gggg");

  //       const [month, year] = currentMonthYear.split(" ");
  //       const monthIndex = months.indexOf(month);

  //       const startDate = new Date(year, monthIndex, 1);
  //       const endDate = new Date(year, monthIndex + 1, 0);

  //       const formatDate = (date) => {
  //         const day = String(date.getDate()).padStart(2, "0");
  //         const month = String(date.getMonth() + 1).padStart(2, "0");
  //         const year = date.getFullYear();
  //         return `${year}-${month}-${day}`;
  //       };

  //       const targetPayload = {
  //         startMonth: formatDate(startDate),
  //         endMonth: formatDate(endDate),
  //       };

  //       const targetData = await getavaliableTarget(targetPayload);
  //       const availableAdminIds = targetData.available_admins.map(
  //         (a) => a.admin_id
  //       );

  //       const missingAdmins = formattedAdmins.filter(
  //         (admin) => !availableAdminIds.includes(admin.id)
  //       );
  //       setAdminOptions(missingAdmins);
  //       if (missingAdmins.length > 0) {
  //         console.log(
  //           "Some active admins are missing from target list:",
  //           missingAdmins
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchAdminsAndTargets();
  // }, []);

  //   useEffect(() => {
  //     GetAllAdminDetails().then((data) => {
  //       const activeAdmins = data.filter(
  //         (item) => !item.Deactived && item.Module !== "Developer"
  //       );
  //       const formattedAdmins = activeAdmins.map((item) => ({
  //         id: item.id,
  //         name: item.userName,
  //       }));
  //       setAdminOptions(formattedAdmins);
  //     });
  //   }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "targetAmount") {
      if (/^\d*$/.test(value)) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
        setErrors((prev) => ({ ...prev, [name]: false }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prev) => ({ ...prev, [name]: false }));

      if (name === "month") {
        const [month, year] = value.split(" ");
        const monthIndex = months.indexOf(month);

        const startDate = new Date(year, monthIndex, 1);
        const endDate = new Date(year, monthIndex + 1, 0);

        const formatDate = (date) => {
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
        };

        const targetPayload = {
          startMonth: formatDate(startDate),
          endMonth: formatDate(endDate),
        };

        getavaliableTarget(targetPayload).then((data) => {
          const availableAdminIds = data.available_admins.map(
            (a) => a.admin_id
          );

          const missingAdmins = admins.filter(
            (admin) => !availableAdminIds.includes(admin.id)
          );
          setAdminOptions(missingAdmins);
          if (missingAdmins.length > 0) {
            console.log(
              "Reminder: These admins don't have targets set:",
              missingAdmins
            );
            // Optionally show alert or modal here
          }
        });
      }
    }
  };
  function handlereOpenForm() {
    const now = new Date();
    const currentMonthYear = `${months[now.getMonth()]} ${now.getFullYear()}`;
    setFormData((prev) => ({ ...prev, month: currentMonthYear }));

    const fetchAdminsAndTargets = async () => {
      try {
        const adminData = await GetAllAdminDetails();
        const activeAdmins = adminData.filter(
          (item) => !item.Deactived && item.module !== "Developer"
        );
        const formattedAdmins = activeAdmins.map((item) => ({
          id: item.id,
          name: item.userName,
        }));
        setAdmins(formattedAdmins);

        const [month, year] = currentMonthYear.split(" ");
        const monthIndex = months.indexOf(month);

        const startDate = new Date(year, monthIndex, 1);
        const endDate = new Date(year, monthIndex + 1, 0);

        const formatDate = (date) => {
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
        };

        const targetPayload = {
          startMonth: formatDate(startDate),
          endMonth: formatDate(endDate),
        };

        const targetData = await getavaliableTarget(targetPayload);
        const availableAdminIds = targetData.available_admins.map(
          (a) => a.admin_id
        );

        const missingAdmins = formattedAdmins.filter(
          (admin) => !availableAdminIds.includes(admin.id)
        );
        setAdminOptions(missingAdmins);
        if (missingAdmins.length > 0) {
          console.log(
            "Some active admins are missing from target list:",
            missingAdmins
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAdminsAndTargets();
  }
  const handleAdminsChange = (event, value) => {
    setFormData((prev) => ({
      ...prev,
      admins: value,
    }));
    setErrors((prev) => ({ ...prev, admins: false }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {
      month: formData.month === "",
      admins: formData.admins.length === 0,
      targetAmount: formData.targetAmount === "",
    };

    setErrors(newErrors);

    const hasError = Object.values(newErrors).some((error) => error);
    if (hasError) return;

    const [selectedMonth, selectedYear] = formData.month.split(" ");
    const monthIndex = months.indexOf(selectedMonth);

    const startDate = new Date(selectedYear, monthIndex, 1);
    const endDate = new Date(selectedYear, monthIndex + 1, 0);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const payload = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      admins: formData.admins.map((admin) => admin.id),
      targetAmount: formData.targetAmount,
    };
    setenableSubmit(true);
    postTargetapi(payload).then((data) => {
      console.log(data);
      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        setenableSubmit(false);
        handleClear();
        onclose();
      }, 2000);
    });

    console.log("Form Data:", payload);
  };

  const handleClear = () => {
    const now = new Date();
    const currentMonthYear = `${months[now.getMonth()]} ${now.getFullYear()}`;
    setFormData({ month: currentMonthYear, admins: [], targetAmount: "" });
    setTargetOpen(false);
    setErrors({ month: false, admins: false, targetAmount: false });
  };

  const isDecember = new Date().getMonth() === 11;

  return (
    <>
      <div>
        <button
          className="btn btn-outline-success"
          onClick={() => {
            setTargetOpen(true);
            handlereOpenForm();
          }}
        >
          Add Target
        </button>
      </div>

      {targetopen && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div className="text-center mb-2">
                  <b>Add Target</b>
                </div>
                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: 300,
                  }}
                >
                  <TextField
                    select
                    label="Select Month"
                    name="month"
                    value={formData.month}
                    onChange={handleChange}
                    fullWidth
                    error={errors.month}
                    helperText={errors.month ? "Month is required" : ""}
                  >
                    {months.map((month, index) => {
                      const now = new Date();
                      const currentYear = now.getFullYear();
                      const currentMonthIndex = now.getMonth(); // 0 = Jan, 11 = Dec

                      // 👇 if current month is December → all months are next year
                      const year =
                        currentMonthIndex === 11
                          ? currentYear + 1
                          : currentYear;

                      const value = `${month} ${year}`;

                      return (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      );
                    })}
                  </TextField>

                  <Autocomplete
                    multiple
                    options={adminOptions}
                    value={formData.admins}
                    onChange={handleAdminsChange}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Admin(s)"
                        placeholder="Admins"
                        error={errors.admins}
                        helperText={
                          errors.admins ? "At least one admin is required" : ""
                        }
                      />
                    )}
                  />

                  <TextField
                    label="Target Amount"
                    type="text"
                    name="targetAmount"
                    value={formData.targetAmount}
                    onChange={handleChange}
                    fullWidth
                    error={errors.targetAmount}
                    helperText={
                      errors.targetAmount ? "Target amount is required" : ""
                    }
                  />

                  <div className="d-flex align-items-center justify-content-end gap-2">
                    <button className="btn btn-danger" onClick={handleClear}>
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success"
                      disabled={enableSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </Box>
              </>
            }
          />
        </MyModal>
      )}

      {showSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={<SuccessTick HeadText="Successfully Created" />}
          />
        </MyModal>
      )}
    </>
  );
};

export default TargetPostForm;
